const SETTINGS_KEY = "ss2026:adv_stats_settings";
const TOUR_KEY = "ss2026:adv_stats_tour_done";
const OPEN_EVENT = "ss2026:open-advanced-stats";

export interface AdvancedStatsSettings {
  tourEnabled: boolean;
  tooltipsEnabled: boolean;
  insightEnabled: boolean;
  learnEnabled: boolean;
}

export const ADV_STATS_DEFAULTS: AdvancedStatsSettings = {
  tourEnabled: true,
  tooltipsEnabled: true,
  insightEnabled: true,
  learnEnabled: true,
};

export function getAdvStatsSettings(): AdvancedStatsSettings {
  if (typeof window === "undefined") return ADV_STATS_DEFAULTS;
  try {
    const raw = window.localStorage.getItem(SETTINGS_KEY);
    if (!raw) return ADV_STATS_DEFAULTS;
    return { ...ADV_STATS_DEFAULTS, ...(JSON.parse(raw) as Partial<AdvancedStatsSettings>) };
  } catch {
    return ADV_STATS_DEFAULTS;
  }
}

export function setAdvStatsSettings(s: AdvancedStatsSettings) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(SETTINGS_KEY, JSON.stringify(s));
}

export function isTourCompleted(): boolean {
  if (typeof window === "undefined") return true;
  return window.localStorage.getItem(TOUR_KEY) === "true";
}

export function markTourCompleted() {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(TOUR_KEY, "true");
}

export function resetTour() {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(TOUR_KEY);
}

export function openAdvancedStats() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(OPEN_EVENT));
}

export function onOpenAdvancedStats(cb: () => void): () => void {
  if (typeof window === "undefined") return () => undefined;
  const handler = () => cb();
  window.addEventListener(OPEN_EVENT, handler);
  return () => window.removeEventListener(OPEN_EVENT, handler);
}